<div class="container-fluid text-center my-container">
        <div class="row my-row align-items-center">

            <div class="col col-sm my-col">
                <div class="row my-row">
                    <div class="col-sm my-col">
                        <img src="/assets/images/{{this.logoFooter}}" class='logoFooter1 pt-4'/>
                    </div>
                </div>
            </div>

            <div class="col col-sm-auto my-col align-middle">
                <ul class="list-inline">
                    <li class="list-inline-item pt-4 pr-5">
                        <a class="nav-link" (click)="downloadFile(this.docMentionsLegales)" target="_blank" download>{{ this.lienMentionsLegales | translate}}</a>
                    </li>
                    <li class="list-inline-item pt-4 pr-5">
                        <a class="nav-link" *ngIf="this.userService.isFullyAuthenticated()"
                        (click)="downloadFile(this.docCgu)" target="_blank" download>
                            {{ this.lienCgu | translate }}
                        </a>
                        <a class="nav-link" *ngIf="!this.userService.isAuthenticated()"
                        (click)="downloadFile(this.docCguPatient)" target="_blank" download>
                            {{ this.lienCguPatient | translate }}
                        </a>
                    </li>
                </ul>
            </div>

            <ng-container *ngIf="this.logoMipih">
                <div class="col col-sm my-col">
                    <img src="/assets/images/logo_mipih.png" alt="Mipih" class='logoFooter1'/>
                </div>
            </ng-container>

            <ng-container *ngIf="!this.logoMipih">
                <div class="col col-sm my-col">
                </div>
            </ng-container>
            
        </div>
</div>
  